<template>
	<div class="pages">
		<sub-ibox-title :is-show-back=false><p slot="title">收银管理</p></sub-ibox-title>
		<z-tabbar :list-obj="tabbarList"></z-tabbar>
		<section>
			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>
		</section>
	</div>
</template>
<script>
	export default {
		name: 'PayManage',
		data() {
			return {
				tabbarList:[{
						title:'收银统计',
						routeName:'payCount'
					},{
						title:'收银记录',
						routeName:'payRecord'
					}]
			}
		},
		methods: {
		}
	}
</script>
<style scoped lang="scss">
@import "src/assets/css/common.scss";
</style>


// WEBPACK FOOTER //
// Index.vue?684bc388